import { Component, OnInit, Inject } from 'ng-metadata/core';
import { AuthoritySearchService } from './authoritySearch.service';
import { SearchResultParser } from '../searchResultParser.service';
import { PagesTitlesService } from '../../infra/accessibility/pagesTitles.service';
import { AuthoritySearchBarService } from './authoritySearchBar/authoritySearchBar.service';
import { SearchStateService } from '../searchState.service';
import { SearchService } from '../search.service';
import { PrimolyticsService, beacon } from '../../analytics/primolytics.service';
import {getAttributesMap} from "../../appConfig/appConfigForward";
import {MediaQueries} from '../../infra/mediaQueries.service';

@Component({
    selector: 'prm-authority-search',
    templateUrl: 'components/search/authority/authority-search.html',
})

export class PrmAuthoritySearch implements OnInit {


    constructor(private authorityService: AuthoritySearchService,
        private pagesTitlesService: PagesTitlesService,
        private authoritySearchBarService: AuthoritySearchBarService,
        private searchStateService: SearchStateService,
        private searchService: SearchService, private mediaQueries: MediaQueries,
        @Inject('$state') private $state: ng.ui.IStateService,
        @Inject('$http') private $http: angular.IHttpService,
        private primolyticsService: PrimolyticsService) {
        this.authorityService.resetParams();
        this.getData();
        this.updatePagesTitles();
        this.searchService.showMobileFacets = true;
    }

    ngOnInit() {
        this.authoritySearchBarService.searchBarInput = this.$state.params['authorityQuery']; //init the search bar text
    }

    get inProgress(): boolean {
        return this.authorityService.inProgress;
    }

    public showResults(): boolean {
        return (this.authorityService.authorityData && !this.inProgress) || (this.authorityService.authorityRequestFailed &&  !this.inProgress);
    }

    get listResult() {
         return this.authorityService.items;
    }


    private updatePagesTitles() {
        let actionToCode = {
            'exploreMain.authsearch': ['mainmenu.label.AuthoritySearch', '$$QUERY$$'],
        };

        let titles = { codes: actionToCode[this.$state.current.name], query: this.authorityQuery };
        this.pagesTitlesService.updatePagesTitles(titles);
    }

    public getData() {
        this.authorityQuery = this.$state.params["authorityQuery"];
        if (this.$state.params['query'] != undefined) {
            return;
        }
        let searchField = this.$state.params["searchField"];
        if (this.$state.params["searchOperator"]) {
            this.authorityService.searchOperator = this.$state.params["searchOperator"];
        }
        if (this.authorityQuery != null) {
            this.runAuthoritySearchBeacon(searchField, this.authorityService.searchOperator);
            this.authorityService.doAuthorityQuery();
        }
    }

    @beacon({ 'p': 'search', 'op': 'authoritySearch' })
    private runAuthoritySearchBeacon(searchField, searchOperator) {
    }

    public get authorityQuery(): string {
        return this.authorityService.authorityQuery;
    }

    public set authorityQuery(value: string) {
        this.authorityService.authorityQuery = value;
    }

    public get searchField(): string {
        return this.authorityService.searchField;
    }

    public set searchField(value: string) {
        this.authorityService.searchField = value;
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }

    get totalResults() {
        if (this.listResult) {
            return this.listResult.length;
        } else {
            return 0;
        }
    };

    private closeMobileFacet($event) {
        this.showMobileFacets = true;
    }

    get showMobileFacets(): boolean {
        return this.searchService.showMobileFacets;
    }

    set showMobileFacets(value: boolean) {
        this.searchService.showMobileFacets = value;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/authority/authoritySearch.directive.ts